export type SizeOptions = { style: 'full'; value?: never } | { style: 'variable'; value: string } | { style: 'fixed'; value: number }

/**
 * Configuration for Media component to render an image,
 * the size property is an object with a style and a value.
 * The style can be 'full', 'variable' or 'fixed'.
 * The value is only required for 'variable' and 'fixed' styles.
 * Variable style expects a regular sizes string, e.g. '(min-width: 600px) 50vw, 100vw'
 * Fixed style expects a number, e.g. 300
 */
export interface ImageConfig {
  alt: string
  size: SizeOptions
  loading?: 'lazy' | 'eager'
  fetchPriority?: 'high' | 'low' | 'auto'
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
  widthAuto?: boolean
}

/**
 * Configuration for Media component to render an video
 */
export interface VideoConfig {
  hasControls: boolean
  autoplay: boolean
  isMuted: boolean
  isLooped: boolean
  posterUrl?: string
}

export const isImage = (media: ImageConfig | VideoConfig): media is ImageConfig => {
  return 'size' in media
}
